<template>
  <div class="teacher-item">
    <div class="avatar-wrap" @click="onAvatarClick">
      <img :src="item.avatar | imgZip(108, 108)" class="avatar" />
      <div v-if="item.showRestNum" class="rest-num">
        仅剩<span>10</span>个名额
      </div>
      <div v-else-if="item.grade && item.grade.grade_level">
        <img
          class="teacher-level"
          :src="
            require(`images/qingsu/homeV2/icon-level-${item.grade.grade_level}.png`)
          "
          alt="等级"
        />
      </div>
    </div>
    <div class="info-wrap-box">
      <div class="info-wrap" @click="onTeacherClick">
        <div class="name">
          <div class="name-left">
            <h5 class="txt">{{ item.nickname }}</h5>
          </div>
          <!-- <div v-if="item.im_status === 0" class="im-online">在线</div> -->
          <div class="qingsu-type" v-if="getQingsuType(item)">
            支持{{ getQingsuType(item) }}
          </div>
          <div class="qingsu-aduit-label" v-if="+item.audit_year">
            <img :src="require('images/qingsu/homeV2/icon-auditing.png')" />
            {{ item.audit_year }}年审通过
          </div>
        </div>
        <p class="desc" v-if="item.qianming">
          {{ item.qianming }}
        </p>
        <div class="teacher-nums-list">
          <div class="teacher-nums-block" v-if="item.qingnum">
            <span> {{ item.qingnum }}人 </span>倾诉
          </div>
          <div class="teacher-nums-block" v-if="item.quick_rate">
            &nbsp;·&nbsp;<span>{{ item.quick_rate }}%</span>响应率
          </div>
        </div>
        <p
          class="good-at"
          :style="
            page === 'qingsuIndexPage' ||
            (+item.invite_gift_pkg && page === 'qingsuInvite')
              ? { width: '4.88rem' }
              : {}
          "
          v-if="goodAtList"
        >
          <span class="good-at-item" v-html="goodAtList"></span>
        </p>
        <div class="teacher-nums" v-if="!hideNums">
          <template
            v-if="
              showCharity && item.rest_charity_num && item.rest_charity_num > 0
            "
          >
            <div class="charity-num">
              公益名额剩{{ item.rest_charity_num }}个
            </div>
          </template>
        </div>
        <div class="recommend" v-if="!isOuterChannel && recommendLabel">
          <img
            v-if="recommendLabel.type === 'icon'"
            :src="
              require(`images/qingsu/indexV3/icon-${recommendLabel.name}.png`)
            "
          />
          <div v-else :class="{ tag: recommendLabel.type === 'tag' }">
            {{ recommendLabel.name }}
          </div>
        </div>
      </div>
      <div class="teacher-status-right" @click="onIconClick">
        <img
          v-if="+item.ting_status === 2"
          class="teacher-status-icon"
          src="~images/qingsu/indexV3/icon-busy.png"
        />
        <img
          v-else-if="+item.ting_status === 1"
          class="teacher-status-icon"
          :src="
            require(`images/qingsu/indexV3/icon-${
              +item.is_provide_voice ? 'online' : 'chat'
            }.png`)
          "
        />
        <img
          v-else
          class="teacher-status-icon"
          src="~images/qingsu/indexV3/icon-offline.png"
        />
        <div v-if="price" class="price-con">
          <slot name=""></slot>
          <template>
            <!-- 邀请有礼4.2优惠券信息 -->
            <template v-if="isQingsuInviteV4">
              <div class="price-new">
                <p class="price">
                  <span class="tag">券后</span>
                  <span class="price-bold"
                    ><span>¥</span>{{ invitePrice
                    }}<span class="price-last">元起</span></span
                  >
                </p>
                <p v-if="price.price" class="price-underline">
                  原价：¥{{ price.price }}
                </p>
              </div>
            </template>
            <template v-else-if="hasNewCoupon">
              <div v-if="page === 'qingsuIndexPage'" class="price-new">
                <p class="price">
                  <span class="tag">券后</span>
                  <span class="price-bold"
                    ><span>¥</span>{{ price.order_price
                    }}<span class="price-last">起</span></span
                  >
                </p>
                <p v-if="price.price" class="price-underline">
                  原价：¥{{ price.price }}
                </p>
              </div>
              <template v-else>
                <p v-if="price.price" class="price-underline">
                  ¥{{ price.price }}
                </p>
                <p class="price-bold"><span>¥</span>{{ price.order_price }}</p>
              </template>
            </template>
            <template
              v-else-if="+item.invite_gift_pkg && page === 'qingsuInvite'"
            >
              <div class="price-new">
                <p class="price">
                  <span class="tag">券后</span>
                  <span class="price-bold"
                    ><span>¥</span>19.9<span class="price-last">起</span></span
                  >
                </p>
                <p v-if="price.price" class="price-underline">
                  原价：¥{{ price.price }}
                </p>
              </div>
            </template>

            <p v-else class="price-bold price-bold-r">
              <span>¥</span>{{ price.order_price }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BigNumber from 'bignumber.js'
import commonMixins from 'app/web/mixins/qingsu/common.js'
import { newVisit, autoReply, receiveNewUserCoupon } from 'api/qingsu'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    hideNums: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: '#ff745b'
    },
    showCharity: {
      type: Boolean,
      default: false
    },
    isTag: {
      type: Boolean,
      default: true
    },
    hidePrice: {
      type: Boolean,
      default: false
    },
    // 点击老师是否跳转到IM
    isClickToChat: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ''
    },
    newUserCoupon: {
      type: Object,
      default: () => {}
    },
    // 邀请有礼4.2优惠券信息
    qingsuInviteCoupon: {
      type: Object,
      default: () => {
        return {}
      }
    },
    qingsuInviteGiftInfo: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [commonMixins],
  computed: {
    // 擅长领域 需求：只显示4个
    goodAtList() {
      const list =
        (this.item.categorys && this.item.categorys.slice(0, 4)) || []
      return list && list.length
        ? list.toString().replace(/,/g, '&nbsp;&nbsp;|&nbsp;&nbsp;')
        : list.toString()
    },
    ...mapGetters(['isLogin']),
    myData() {
      return this.$store.state.qingsuindex.myData
    },
    remnderIds() {
      return this.$store.state.qingsuindex.remnderIds
    },
    isApp() {
      return (
        this.$platform.isYixinliApp ||
        this.$platform.isZiXunApp ||
        this.$platform.isQingSuApp
      )
    },
    recommendLabel() {
      const { like_labels } = this.item
      let label = null
      if (like_labels && like_labels.length) {
        const target = like_labels[0]
        if (target.includes('已入驻') || target.includes('咨询师资质')) {
          label = {
            type: 'tag',
            name: target
          }
        } else {
          switch (target) {
            case '热门TOP30':
              label = {
                type: 'icon',
                name: 'qingsu-top'
              }
              break
            case '近期入驻TOP50':
              label = {
                type: 'icon',
                name: 'new-join'
              }
              break
            case '好评TOP50':
              label = {
                type: 'icon',
                name: 'good-rate'
              }
              break
            case '人气飙升TOP50':
              label = {
                type: 'icon',
                name: 'qingsu-hot'
              }
              break
            case '快速响应':
              label = {
                type: 'icon',
                name: 'quick-reply'
              }
              break
            case '12.12嘉年华':
              label = {
                type: 'icon',
                name: 'anniversary'
              }
              break
            default:
              label = {
                type: 'text',
                name: target
              }
          }
        }
      }
      return label
    },
    trackParams() {
      return {
        page_title: this.$route.meta.pageName,
        listener_id: this.item.user_id,
        listener_name: this.item.nickname,
        listener_state: ['已休息', '空闲', '服务中'][this.item.ting_status],
        online_status: ['在线', '离线'][this.item.im_status],
        is_newlistenvisitor: this.$store.state.qingsuindex.isNewVisit,
        is_newlistenervisitor: this.$store.state.qingsuindex.isNewTeacherVisit
      }
    },
    isTeacher() {
      // 0:普通用户，1：单咨询师，2：单倾听师，3：咨询师+倾听师
      return +this.$store.state.qingsuindex.isTeacher
    },
    hasNewCoupon() {
      const { is_new, first_discount_wait } = this.newUserCoupon || {}
      // 新用户&&第一单不在退款中
      return +is_new && !+first_discount_wait
    },
    price() {
      if (this.hidePrice) return null
      const { price, first_order, is_free_channel } = this.item
      if (price && price.length) {
        const originPrice = +price[0].price
        const order_price =
          originPrice < 38.1 // 老师自定义价格如果低于38.1元，优惠价为0
            ? 0
            : new BigNumber(originPrice).minus(38.1).toNumber()
        const res = {
          first_order: !!+first_order,
          ...price[0],
          price: originPrice,
          order_price
        }

        // 公益老师
        if (+is_free_channel) {
          res.order_price = 0
        } else if (!this.hasNewCoupon) {
          // 非首单
          res.order_price = price[0].price
        }

        return res
      }
      return null
    },
    isOuterChannel() {
      const { cid = '', cp_channel_id = '' } = this.$route.query
      return cid || cp_channel_id
    },
    isUnNeedToLogin() {
      // 小程序不需要强制登录，以免被封
      return this.isWebviewMp
    },
    // 是否邀请有礼4.0
    isQingsuInviteV4() {
      return this.page === 'qingsuInvite' && this.qingsuInviteCoupon.coupon_id
    },
    invitePrice() {
      const { user_group } = this.$route.query
      const { is_receive, coupon_price } = this.qingsuInviteGiftInfo
      return +is_receive === 1
        ? coupon_price
        : this.qingsuInviteCoupon.price || +this.qingsuInviteCoupon.price === 0
        ? this.qingsuInviteCoupon.price
        : +user_group === 1
        ? 0.9
        : 9.9
    }
  },
  methods: {
    getNewVisit() {
      return new Promise(resolve => {
        newVisit({ to_user_id: this.item.user_id }).then(res => {
          if (res.code === 0) {
            resolve(res.data)
          }
        })
      })
    },
    // genRate(item) {
    //   const ratePencent = +item.rate_pencent
    //   if (!isNaN(ratePencent)) {
    //     // 使用bignumber.js解决JS计算中出现的精度问题，比如0.14*100=14.000000000000002
    //     const x = new BigNumber(ratePencent)
    //     const y = new BigNumber(100)
    //     return x.multipliedBy(y).toNumber() + '%'
    //   }
    // },
    // showRate(item) {
    //   return +item.rate_pencent !== 0 && this.genRate(item)
    // },
    showTags(tag) {
      if (Object.prototype.toString.call(tag) === '[object Object]') {
        return [tag]
      }
      if (Array.isArray(tag) && tag.length > 0) {
        return tag[0]
      }
      return []
    },
    async onAvatarClick() {
      const data = await this.getNewVisit()
      const { is_new_visit, is_new_teacher_visit } = data
      const { is_provide_text, is_provide_voice } = this.item
      this.$trackEvent('listenhomepage_teacher_avatar_click', {
        ...this.trackParams,
        is_newlistenvisitor: is_new_visit,
        is_newlistenervisitor: is_new_teacher_visit,
        provide_services: [
          +is_provide_text ? '文字' : '',
          +is_provide_voice ? '语音' : ''
        ].filter(v => !!v)
      })
      // 如果是邀请有礼4.0，优先跳转下订单页面
      if (this.isQingsuInviteV4) return this.$emit('click')
      await this.receiveNewUserCoupon()
      this.$emit('click')
    },
    async onIconClick() {
      // 如果是邀请有礼4.0，优先跳转下订单页面
      if (this.isQingsuInviteV4) {
        const data = await this.getNewVisit()
        this.iconClickTrack(data)
        return this.$emit('click')
      }

      const userId = this.$store.state?.userinfo?.id || ''
      const listUserId = this.item.user_id
      const isTeacherSelf = userId == listUserId
      await this.receiveNewUserCoupon()
      if (this.$platform.isYixinliApp && this.isClickToChat && !isTeacherSelf) {
        this.toChat()
      } else {
        const data = await this.getNewVisit()
        this.iconClickTrack(data)
        this.$emit('click')
      }
    },
    async iconClickTrack(data) {
      const { is_new_visit, is_new_teacher_visit } = data
      const { is_provide_text, is_provide_voice } = this.item
      this.$trackEvent('listenhomepage_teacher_icon_click', {
        ...this.trackParams,
        is_newlistenvisitor: is_new_visit,
        is_newlistenervisitor: is_new_teacher_visit,
        provide_services: [
          +is_provide_text ? '文字' : '',
          +is_provide_voice ? '语音' : ''
        ].filter(v => !!v)
      })
    },
    async onTeacherClick() {
      // 如果是邀请有礼4.0，优先跳转下订单页面
      if (this.isQingsuInviteV4) {
        const data = await this.getNewVisit()
        this.teacherClickTrack(data)
        return this.$emit('click')
      }

      const userId = this.$store.state?.userinfo?.id || ''
      const listUserId = this.item.user_id
      const isTeacherSelf = userId == listUserId
      await this.receiveNewUserCoupon()
      if (this.$platform.isYixinliApp && this.isClickToChat && !isTeacherSelf) {
        this.toChat()
      } else {
        const data = await this.getNewVisit()
        this.teacherClickTrack(data)
        this.$emit('click')
      }
    },
    async teacherClickTrack(data) {
      const { is_new_visit, is_new_teacher_visit } = data
      const { like_labels, is_provide_text, is_provide_voice } = this.item
      this.$trackEvent('listenhomepage_teacher_click', {
        page_title: this.$route.meta.pageName,
        listener_id: this.item.user_id,
        listener_name: this.item.nickname,
        listener_state: ['已休息', '空闲', '服务中'][this.item.ting_status],
        online_status: ['在线', '离线'][this.item.im_status],
        is_newlistenvisitor: is_new_visit,
        is_newlistenervisitor: is_new_teacher_visit,
        recommend: like_labels ? like_labels[0] : '',
        provide_services: [
          +is_provide_text ? '文字' : '',
          +is_provide_voice ? '语音' : ''
        ].filter(v => !!v)
      })
    },
    async toChat() {
      Promise.all([
        this.getNewVisit(),
        autoReply({ qingting_id: this.item.user_id })
      ]).then(res => {
        this.teacherClickTrack(res[0])
        window.location.href = `yixinli://open_chat?user_id=${this.item.user_id}`
      })
    },
    async receiveNewUserCoupon() {
      await this.$store.dispatch('getUserInfo')
      if (
        this.isLogin &&
        this.page === 'qingsuIndexPage' &&
        this.hasNewCoupon &&
        !+this.newUserCoupon.is_receive
      ) {
        let code = 0
        const res = await receiveNewUserCoupon()
        code = res.code
        if (code === 0) {
          this.eventStat('新人优惠券领取成功')
        }
      }
    },
    getQingsuType(item) {
      const { is_provide_text, is_provide_voice } = item
      if (is_provide_voice && is_provide_text) {
        return '语音/文字'
      }
      if (is_provide_voice) {
        return '语音'
      }
      if (is_provide_text) {
        return '文字'
      }
      return ''
    },
    // 跳转下订单页面
    toQingsuOrderPageV2() {
      this.routerToStaicWithoutNav({
        path: '/qingsu-order-page-v2',
        query: {
          to_user_id: this.item.user_id,
          channel_flag: 'qs_yqylxr',
          orderType: 'voice',
          coupon_id: this.qingsuInviteCoupon.coupon_id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-item {
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  &:first-child {
    padding-top: 20px;
  }
  .avatar-wrap {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-right: 20px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    .rest-num {
      position: absolute;
      left: -17px;
      bottom: -16px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 143px;
      height: 32px;
      background: #ffebd5;
      border-radius: 19px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      span {
        color: #ec4a25;
      }
    }
    .teacher-level {
      position: absolute;
      left: 3px;
      bottom: -29px;
      width: 94px;
      height: 36px;
      border-radius: 0;
    }
  }
  .info-wrap-box {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    padding-bottom: 30px;
    position: relative;
    min-height: 140px;
    &:after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height: pxToRem(2);
      background: #f3f4f5;
      transform: scaleY(0.6);
    }
  }

  .teacher-status-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-left: auto;
    position: relative;
    .teacher-status-icon {
      width: 100%;
      height: 100%;
    }
    .price-con {
      position: absolute;
      display: flex;
      align-items: baseline;
      top: 88px;
      right: 8px;
      .price-underline {
        font-size: 22px;
        color: #bcc2cf;
        text-decoration: line-through;
        margin-right: 6px;
      }
      .price-bold {
        font-weight: bold;
        color: #ffa202;
        font-size: 32px;
        span {
          font-size: 20px;
        }
        &.price-bold-r {
          margin-right: 5px;
        }
      }
      .price-new {
        width: 2.3rem;
        .price {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .tag {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            width: 48px;
            height: 28px;
            background: #ff745b;
            border-radius: 6px 6px 0px 6px;

            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
          }
          .price-bold .price-last {
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffa202;
            line-height: 28px;
            margin-left: 4px;
          }
        }
        .price-underline {
          text-align: right;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #bcc2cf;
        }
      }
    }
  }
  .name {
    max-width: 460px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 19px;
    white-space: nowrap;
    overflow: hidden;
    .name-left {
      display: flex;
      line-height: 1;
      .txt {
        display: inline-block;
        max-width: 134px;
        height: 100%;
        font-size: 32px;
        color: #333;
        font-weight: 600;
        margin-right: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .qingsu-type {
      font-size: 22px;
      color: #21252d;
      line-height: 22px;
      padding: 5px 6px 4px;
      position: relative;
      &::after {
        content: ' ';
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #9da3ac;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        box-sizing: border-box;
        border-radius: 12px;
      }
    }
  }
  .im-online {
    color: #6982fa;
    font-size: 20px;
    margin-right: 12px;
    position: relative;
    padding-left: 20px;
    &:before {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #6982fa;
      display: block;
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .desc {
    width: 432px;
    font-size: 24px;
    color: #434c5c;
    text-align: justify;
    line-height: 26px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .teacher-nums {
    font-size: 0;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-dot {
    color: #9da3ac;
    font-size: 24px;
  }
  .teacher-nums-list {
    margin-top: 17px;
  }
  .teacher-nums-block {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    line-height: 24px;
    color: #434c5c;
    span {
      color: #21252d;
      font-weight: 600;
    }
  }
  .charity-num {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    line-height: 30px;
    color: #ff745b;
    border-radius: 6px;
    padding: 2px 6px;
    border: 1px solid #ff745b;
  }
  .good-at {
    max-width: 423px;
    display: flex;
    font-size: 24px;
    color: #6c798c;
    margin: 18px 0 20px;
    .good-at-item {
      height: 40px;
      line-height: 40px;
      padding: 0 8px;
      border-radius: 6px;
      background: #f2f4ff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .recommend {
    font-size: 22px;
    color: #ff745b;
    line-height: 22px;
    .tag {
      position: relative;
      display: inline-block;
      color: #ffa202;
      padding: 5px 6px 4px;
      &::after {
        content: ' ';
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #ffa202;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        box-sizing: border-box;
        border-radius: 8px;
      }
    }
    img {
      height: 30px;
      width: auto;
    }
  }
  .qingsu-aduit-label {
    display: flex;
    align-items: center;
    height: 30px;
    font-size: 17px;
    color: #6466bb;
    font-weight: 600;
    line-height: 23px;
    padding: 0 8px 0 3px;
    background: #eef1ff;
    border-radius: 8px;
    margin-left: 10px;
    img {
      display: block;
      width: 29px;
      margin-right: 2px;
    }
  }
}

.teacher-item:last-of-type {
  .info-wrap {
    border-bottom: 2px solid transparent;
  }
}
</style>
